export default __webpack_public_path__ + "static/media/undraw_medicine.db6dd6e1.svg";